import { CircularProgress, Typography } from '@mui/material';
import { Box, ThemeProvider } from '@mui/system';
import { PrimeReactProvider } from 'primereact/api';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { Layout } from './components/Layout';
import './dataTable.css';

import 'primeicons/primeicons.css'; // Ícones do PrimeReact
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
//import 'primereact/resources/themes/saga-blue/theme.css';  // Ou outro tema
import 'primereact/resources/primereact.min.css';

import moment from 'moment-timezone'; // Moment com suporte a timezones
import { SnackbarProvider, closeSnackbar } from 'notistack';
import 'primeicons/primeicons.css';
import configUrls from './config/configUrls';
import HomePage from './features/aHome/HomePage';
import { NotFoundPage } from './features/aHome/NotFoundPage';
import { BlocoCreate } from './features/bloco/BlocoCreate';
import { BlocoEdit } from './features/bloco/BlocoEdit';
import { BlocoList } from './features/bloco/BlocoList';
import { GrupoCreate } from './features/grupo/GrupoCreate';
import { GrupoEdit } from './features/grupo/GrupoEdit';
import { GrupoList } from './features/grupo/GrupoList';
import { ProcessoGerarDocumentoCreate } from './features/iniciarDocumento/createDocumento/ProcessoGerarDocumentoCreate';
import { ProcessoGerarDocumentoEdit } from './features/iniciarDocumento/createDocumento/ProcessoGerarDocumentoEdit';
import { DocumentoAndamentoListForm } from './features/iniciarDocumento/documentoAtualizarAndamento/DocumentoAndamentoListForm';
import { DocumentoAtualizarAndamentoCreate } from './features/iniciarDocumento/documentoAtualizarAndamento/DocumentoAtualizarAndamentoCreate';
import { DocumentoComentarioCreate } from './features/iniciarDocumento/documentoComentario/DocumentoComentarioCreate';
import { DocumentoComentarioListForm } from './features/iniciarDocumento/documentoComentario/DocumentoComentarioListForm';
import { DocumentoDarCienciaListForm } from './features/iniciarDocumento/documentoDarCiencia/DocumentoDarCienciaListForm';
import { DocumentoEmailCreateForm } from './features/iniciarDocumento/documentoEnviarEmail/DocumentoEmailCreateForm';
import { DocumentoEmailListForm } from './features/iniciarDocumento/documentoEnviarEmail/DocumentoEmailListForm';
import { DocumentoFavoritoCreateForm } from './features/iniciarDocumento/documentoFavorito/DocumentoFavoritoCreateForm';
import { DocumentoFavoritoListForm } from './features/iniciarDocumento/documentoFavorito/DocumentoFavoritoListForm';
import { DocumentoView } from './features/iniciarDocumento/documentoView/DocumentoView';
import { ProcessoAcompanhamentoCreate } from './features/iniciarProcesso/processoAcompanhamento/ProcessoAcompanhamentoCreate';
import { ProcessoAcompanhamentoList } from './features/iniciarProcesso/processoAcompanhamento/ProcessoAcompanhamentoList';
import { ProcessoAtribuirCreate } from './features/iniciarProcesso/processoAtribuir/ProcessoAtribuirCreate';
import { ProcessoAtribuirListForm } from './features/iniciarProcesso/processoAtribuir/ProcessoAtribuirListForm';
import { ProcessoAndamentoListForm } from './features/iniciarProcesso/processoAtualizarAndamento/ProcessoAndamentoListForm';
import { ProcessoAtualizarAndamentoCreate } from './features/iniciarProcesso/processoAtualizarAndamento/ProcessoAtualizarAndamentoCreate';
import { ProcessoAnotacaoListForm } from './features/iniciarProcesso/processoAtualizarAnotacao/ProcessoAnotacaoListForm';
import { ProcessoAtualizarAnotacaoCreate } from './features/iniciarProcesso/processoAtualizarAnotacao/ProcessoAtualizarAnotacaoCreate';
import { ProcessoBlocoCreate } from './features/iniciarProcesso/processoBloco/ProcessoBlocoCreate';
import { ProcessoBlocoListForm } from './features/iniciarProcesso/processoBloco/ProcessoBlocoListForm';
import { ProcessoComentarioCreate } from './features/iniciarProcesso/processoComentario/ProcessoComentarioCreate';
import { ProcessoComentarioListForm } from './features/iniciarProcesso/processoComentario/ProcessoComentarioListForm';
import { ProcessoConcluirForm } from './features/iniciarProcesso/processoConcluir/ProcessoConcluirForm';
import { ProcessoConcluirListForm } from './features/iniciarProcesso/processoConcluir/ProcessoConcluirListForm';
import { ProcessoCreate } from './features/iniciarProcesso/ProcessoCreate';
import { ProcessoDarCienciaListForm } from './features/iniciarProcesso/processoDarCiencia/ProcessoDarCienciaListForm';
import { ProcessoEnviarForm } from './features/iniciarProcesso/processoEnviar/ProcessoEnviarForm';
import { ProcessoEnviarListForm } from './features/iniciarProcesso/processoEnviar/ProcessoEnviarListForm';
import { ProcessoFormView } from './features/iniciarProcesso/ProcessoFormView';
import { ProcessoList } from './features/iniciarProcesso/ProcessoList';
import { ProcessoMarcadorCreate } from './features/iniciarProcesso/processoMarcador/ProcessoMarcadorCreate';
import { ProcessoMarcadorListForm } from './features/iniciarProcesso/processoMarcador/ProcessoMarcadorListForm';
import { ProcessoPrazoForm } from './features/iniciarProcesso/processoPrazo/ProcessoPrazoForm';
import { ProcessoPrazoListForm } from './features/iniciarProcesso/processoPrazo/ProcessoPrazoListForm';
import { ProcessoSobrestarForm } from './features/iniciarProcesso/processoSobrestar/ProcessoSobrestarForm';
import { ProcessoSobrestarListForm } from './features/iniciarProcesso/processoSobrestar/ProcessoSobrestarListForm';
import Login from './features/login/Login';
import { MarcadorCreate } from './features/marcador/MarcadorCreate';
import { MarcadorListForm } from './features/marcador/MarcadorListForm';
import { OrgaoCreate } from './features/orgao/OrgaoCreate';
import { OrgaoList } from './features/orgao/OrgaoList';
import { SecretariaCreate } from './features/secretaria/SecretariaCreate';
import { SecretariaEdit } from './features/secretaria/SecretariaEdit';
import { SecretariaList } from './features/secretaria/SecretariaList';
import { SetorCreate } from './features/setor/SetorCreate';
import { SetorEdit } from './features/setor/SetorEdit';
import { SetorList } from './features/setor/SetorList';
import { TipoDocumentoCreate } from './features/tipoDocumento/TipoDocumentoCreate';
import { TipoDocumentoEdit } from './features/tipoDocumento/TipoDocumentoEdit';
import { TipoDocumentoList } from './features/tipoDocumento/TipoDocumentoList';
import { TipoProcessoCreate } from './features/tipoProcesso/TipoProcessoCreate';
import { TipoProcessoEdit } from './features/tipoProcesso/TipoProcessoEdit';
import { TipoProcessoList } from './features/tipoProcesso/TipoProcessoList';

import { DocumentoAssinarListForm } from './features/iniciarDocumento/documentoAssinar/DocumentoAssinarListForm';
import { DocumentoAssinarView } from './features/iniciarDocumento/documentoAssinar/DocumentoAssinarView';
import { DocumentoEditar } from './features/iniciarDocumento/documentoEditar/DocumentoEditar';
import { DocumentoEditarView } from './features/iniciarDocumento/documentoVersao/DocumentoEditarView';
import { DocumentoVersaoListForm } from './features/iniciarDocumento/documentoVersao/DocumentoVersaoListForm';

import { useLoadTheme } from './config/loadThemeFromJson';
import configSiteUrls from './features/site/configs/configSiteUrls';

import { useOrgaoRoutes } from './config/useOrgaoRoutes';
import { useSecretariaRoutes } from './config/useSecretariaRoutes';
import { useSetorRoutes } from './config/useSetorRoutes';
import { ForbiddenPage } from './features/aHome/ForbiddenPage';
import { AcessoInformacaoListForm } from './features/site/features/acessoInformacao/admin/AcessoInformacaoListForm';
import { AcessoInformacaoConsultaView } from './features/site/features/acessoInformacao/create/AcessoInformacaoConsultaView';
import { AcessoInformacaoCreate } from './features/site/features/acessoInformacao/create/AcessoInformacaoCreate';
import { AcessoInformacaoEdit } from './features/site/features/acessoInformacao/create/AcessoInformacaoEdit';
import AcessoInformacaoMenu from './features/site/features/acessoInformacao/create/AcessoInformacaoMenu';
import { CentroApoioListForm } from './features/site/features/centroApoio/admin/CentroApoioListForm';
import { CentroApoioConsultaView } from './features/site/features/centroApoio/create/CentroApoioConsultaView';
import { CentroApoioCreate } from './features/site/features/centroApoio/create/CentroApoioCreate';
import { CentroApoioEdit } from './features/site/features/centroApoio/create/CentroApoioEdit';
import CentroApoioMenu from './features/site/features/centroApoio/create/CentroApoioMenu';
import { LicitacaoCreate } from './features/site/features/licitacao/create/LicitacaoCreate';
import { LicitacaoListForm } from './features/site/features/licitacao/create/LicitacaoListForm';
import { LicitacaoPublicList } from './features/site/features/licitacao/listPublic/LicitacaoPublicList';
import { MenuFilhoCreate } from './features/site/features/menus/menufilho/MenuFilhoCreate';
import { MenuFilhoListForm } from './features/site/features/menus/menufilho/MenuFilhoListForm';
import { MenuNetoCreate } from './features/site/features/menus/menuNeto/MenuNetoCreate';
import { MenuNetoListForm } from './features/site/features/menus/menuNeto/MenuNetoListForm';
import { MenuPaiCreate } from './features/site/features/menus/menuPai/MenuPaiCreate';
import { MenuPaiListForm } from './features/site/features/menus/menuPai/MenuPaiListForm';
import { NoticiaCreateForm } from './features/site/features/noticia/create/NoticiaCreateForm';
import { NoticiaListForm } from './features/site/features/noticia/listAdmin/NoticiaListForm';
import { NoticiaPublicList } from './features/site/features/noticia/listPublic/NoticiaPublicList';
import { NoticiaView } from './features/site/features/noticia/view/NoticiaView';
import { OuvidoriaListForm } from './features/site/features/ouvidoria/admin/OuvidoriaListForm';
import { OuvidoriaConsultaView } from './features/site/features/ouvidoria/create/OuvidoriaConsultaView';
import { OuvidoriaCreate } from './features/site/features/ouvidoria/create/OuvidoriaCreate';
import { OuvidoriaEdit } from './features/site/features/ouvidoria/create/OuvidoriaEdit';
import OuvidoriaMenu from './features/site/features/ouvidoria/create/OuvidoriaMenu';
import { PublicacaoOficialCreate } from './features/site/features/publicacaoOficial/create/PublicacaoOficialCreate';
import { PublicacaoOficialListForm } from './features/site/features/publicacaoOficial/create/PublicacaoOficialListForm';
import { PublicacaoOficialPublicList } from './features/site/features/publicacaoOficial/listPublic/PublicacaoOficialPublicList';
import { TipoPublicacaoOficialCreate } from './features/site/features/tipoPublicacaoOficial/tipoPublicacaoOficialCreate';
import { TipoPublicacaoOficialListForm } from './features/site/features/tipoPublicacaoOficial/tipoPublicacaoOficialListForm';
import { VereadorCreate } from './features/site/features/vereador/vereadorCreate';
import { VereadorListForm } from './features/site/features/vereador/vereadorListForm';
import EscolaLegislativoHome from './features/site/home/EscolaLegislativoHome';
import SiteHome from './features/site/features/home/SiteHome';
import { UsuarioCreate } from './features/usuario/usuarioCreate';
import { UsuarioListForm } from './features/usuario/usuarioListForm';

moment.tz.setDefault('America/Sao_Paulo'); // Define o timezone padrão

function App() {
  const secretariaRoutes = useSecretariaRoutes();
  const orgaoRoutes = useOrgaoRoutes();
  const setorRoutes = useSetorRoutes();

  const themeToAppy = useLoadTheme();

  if (!themeToAppy) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
        <Typography variant="h6" color="error" style={{ marginTop: 20 }}>
          O tema não foi localizado. Tentando carregar o tema padrão...
        </Typography>
      </Box>
    );
  }

  return (
    <PrimeReactProvider>
      <ThemeProvider theme={themeToAppy}>
        <SnackbarProvider
          preventDuplicate
          maxSnack={3}
          autoHideDuration={3000}
          style={{ whiteSpace: 'pre-line' }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          action={snackbarId => <button onClick={() => closeSnackbar(snackbarId)}>x</button>}
        >
          <div
            //component="main"
            className="center-top"
          >
            {/*<Header />*/}

            <Layout>
              <Routes>
                {/* *************Rotas  de Bloco */}
                <Route path="/cadastro/bloco/create" element={<BlocoCreate />} />
                <Route path="/cadastro/bloco/edit/:id" element={<BlocoEdit />} />
                <Route path="/cadastro/bloco/list" element={<BlocoList />} />
                {/* *************Rotas  de Grupo */}
                <Route path="/cadastro/grupo/create" element={<GrupoCreate />} />
                <Route path="/cadastro/grupo/edit/:id" element={<GrupoEdit />} />
                <Route path="/cadastro/grupo/list" element={<GrupoList />} />
                {/* *************Rotas  de Tipo de Processo */}
                <Route path={configUrls.TIPO_PROCESSO_LIST_RT} element={<TipoProcessoList />} />
                <Route path={configUrls.TIPO_PROCESSO_CREATE_RT} element={<TipoProcessoCreate />} />
                <Route path={configUrls.TIPO_PROCESSO_EDIT_RT} element={<TipoProcessoEdit />} />
                {/* *************Rotas  de Tipo de Documento */}
                <Route path={configUrls.TIPO_DOCUMENTO_LIST_RT} element={<TipoDocumentoList />} />
                <Route path={configUrls.TIPO_DOCUMENTO_CREATE_RT} element={<TipoDocumentoCreate />} />
                <Route path={configUrls.TIPO_DOCUMENTO_EDIT_RT} element={<TipoDocumentoEdit />} />
                {/* *************Rotas  de Processo */}
                <Route path={configUrls.PROCESSO_CREATE_RT} element={<ProcessoCreate />} />
                <Route path={configUrls.PROCESSO_EDIT_RT} element={<ProcessoCreate />} />
                <Route path={configUrls.PROCESSO_FORM_VIEW} element={<ProcessoFormView />} />
                <Route path={configUrls.PROCESSO_LIST_RT} element={<ProcessoList />} />
                {/* *************Rotas  de Processo Gerar Documento */}
                <Route path={configUrls.PROCESSO_GERAR_DOCUMENTO_CREATE_RT} element={<ProcessoGerarDocumentoCreate />} />
                <Route path={configUrls.PROCESSO_DOCUMENTO_VIEW} element={<DocumentoView />} />
                <Route path={configUrls.PROCESSO_GERAR_DOCUMENTO_EDIT_RT} element={<ProcessoGerarDocumentoEdit />} />
                {/* *************Rotas  de Dar Ciência */}
                <Route path={configUrls.PROCESSO_CIENCIA_LIST} element={<ProcessoDarCienciaListForm />} />
                {/* *************Rotas  de Setor */}
                <Route path={setorRoutes.SETOR_LIST} element={<SetorList />} />
                <Route path={setorRoutes.SETOR_CREATE} element={<SetorCreate />} />
                <Route path={setorRoutes.SETOR_EDIT} element={<SetorEdit />} />
                {/* *************Rotas  de Órgão */}
                <Route path={orgaoRoutes.ORGAO_LIST} element={<OrgaoList />} />
                <Route path={orgaoRoutes.ORGAO_CREATE} element={<OrgaoCreate />} />
                <Route path={orgaoRoutes.ORGAO_EDIT} element={<OrgaoCreate />} />
                {/* *************Rotas  de Secretaria saber */}
                <Route path={secretariaRoutes.SECRETARIA_LIST} element={<SecretariaList />} />
                <Route path={secretariaRoutes.SECRETARIA_CREATE} element={<SecretariaCreate />} />
                <Route path={secretariaRoutes.SECRETARIA_EDIT} element={<SecretariaEdit />} />

                {/* *************Rotas  de Secretaria site */}

                {/* *************Rotas  de Acompanhamento de Processo */}
                <Route path={configUrls.PROCESSO_ACOMPANHAMENTO_LIST_RT} element={<ProcessoAcompanhamentoList />} />
                <Route path={configUrls.PROCESSO_ACOMPANHAMENTO_CREATE_RT} element={<ProcessoAcompanhamentoCreate />} />
                {/* *************Rotas  de Histórico de Processo */}
                <Route path={configUrls.PROCESSO_HISTORICO_CREATE_RT} element={<ProcessoAtualizarAndamentoCreate />} />
                <Route path={configUrls.PROCESSO_HISTORICO_LIST_RT} element={<ProcessoAndamentoListForm />} />
                {/* *************Rotas  de Anotação de Processo */}
                <Route path={configUrls.PROCESSO_ANOTACAO_CREATE_RT} element={<ProcessoAtualizarAnotacaoCreate />} />
                <Route path={configUrls.PROCESSO_ANOTACAO_LIST_RT} element={<ProcessoAnotacaoListForm />} />
                <Route path={configUrls.PROCESSO_ANOTACAO_EDIT_RT} element={<ProcessoAtualizarAnotacaoCreate />} />
                {/* *************Rotas  de Comentário de Processo */}
                <Route path={configUrls.PROCESSO_COMENTARIO_CREATE_RT} element={<ProcessoComentarioCreate />} />
                <Route path={configUrls.PROCESSO_COMENTARIO_LIST_RT} element={<ProcessoComentarioListForm />} />
                <Route path={configUrls.PROCESSO_COMENTARIO_EDIT_RT} element={<ProcessoComentarioCreate />} />
                {/* *************Rotas  de Marcador de Processo */}
                <Route path={configUrls.PROCESSO_MARCADOR_CREATE_RT} element={<ProcessoMarcadorCreate />} />
                <Route path={configUrls.PROCESSO_MARCADOR_LIST_RT} element={<ProcessoMarcadorListForm />} />
                <Route path={configUrls.PROCESSO_MARCADOR_EDIT_RT} element={<ProcessoMarcadorCreate />} />
                {/* *************Rotas  de Atribuir Processo */}
                <Route path={configUrls.PROCESSO_ATRIBUIR_CREATE_RT} element={<ProcessoAtribuirCreate />} />
                <Route path={configUrls.PROCESSO_ATRIBUIR_LIST_RT} element={<ProcessoAtribuirListForm />} />
                {/* *************Rotas  de Bloco de Processo */}
                <Route path={configUrls.PROCESSO_BLOCO_CREATE_RT} element={<ProcessoBlocoCreate />} />
                <Route path={configUrls.PROCESSO_BLOCO_LIST_RT} element={<ProcessoBlocoListForm />} />
                {/* *************Rotas  de Enviar Processo */}
                <Route path={configUrls.PROCESSO_ENVIAR_CREATE_RT} element={<ProcessoEnviarForm />} />
                <Route path={configUrls.PROCESSO_ENVIAR_LIST_RT} element={<ProcessoEnviarListForm />} />
                {/* *************Rotas  de Sobrestar Processo */}
                <Route path={configUrls.PROCESSO_SOBRESTAR_CREATE_RT} element={<ProcessoSobrestarForm />} />
                <Route path={configUrls.PROCESSO_SOBRESTAR_LIST_RT} element={<ProcessoSobrestarListForm />} />
                {/* *************Rotas  de Concluir Processo */}
                <Route path={configUrls.PROCESSO_CONCLUIR_CREATE_RT} element={<ProcessoConcluirForm />} />
                <Route path={configUrls.PROCESSO_CONCLUIR_LIST_RT} element={<ProcessoConcluirListForm />} />
                {/* *************Rotas  de Prazo de Processo */}
                <Route path={configUrls.PROCESSO_PRAZO_CREATE_RT} element={<ProcessoPrazoForm />} />
                <Route path={configUrls.PROCESSO_PRAZO_LIST_RT} element={<ProcessoPrazoListForm />} />
                {/* *************Rotas  de Documento Dar Ciência */}
                <Route path={configUrls.DOCUMENTO_CIENCIA_LIST} element={<DocumentoDarCienciaListForm />} />
                {/* *************Rotas  de Histórico de Documento */}
                <Route path={configUrls.DOCUMENTO_HISTORICO_LIST_RT} element={<DocumentoAndamentoListForm />} />
                <Route path={configUrls.DOCUMENTO_HISTORICO_CREATE_RT} element={<DocumentoAtualizarAndamentoCreate />} />
                {/* *************Rotas  de Favoritos de Documento */}
                <Route path={configUrls.DOCUMENTO_FAVORITO_LIST_RT} element={<DocumentoFavoritoListForm />} />
                <Route path={configUrls.DOCUMENTO_FAVORITO_CREATE_RT} element={<DocumentoFavoritoCreateForm />} />
                {/* *************Rotas  de Email de Documento */}
                <Route path={configUrls.DOCUMENTO_EMAIL_LIST_RT} element={<DocumentoEmailListForm />} />
                <Route path={configUrls.DOCUMENTO_EMAIL_CREATE_RT} element={<DocumentoEmailCreateForm />} />
                {/* *************Rotas  de Marcador */}
                <Route path={configUrls.MARCADOR_CREATE_RT} element={<MarcadorCreate />} />
                <Route path={configUrls.MARCADOR_LIST_RT} element={<MarcadorListForm />} />
                <Route path={configUrls.MARCADOR_EDIT_RT} element={<MarcadorCreate />} />
                {/* *************Rotas  de Comentário de Documento */}
                <Route path={configUrls.DOCUMENTO_COMENTARIO_LIST_RT} element={<DocumentoComentarioListForm />} />
                <Route path={configUrls.DOCUMENTO_COMENTARIO_CREATE_RT} element={<DocumentoComentarioCreate />} />
                {/* *************Rotas  de Versão de Documento */}
                <Route path={configUrls.DOCUMENTO_VERSAO_LIST_RT} element={<DocumentoVersaoListForm />} />
                {/* *************Rotas  de Edição de Documento */}
                <Route path={configUrls.DOCUMENTO_EDITAR_RT} element={<DocumentoEditar />} />
                <Route path={configUrls.DOCUMENTO_VERSAO_VIEW} element={<DocumentoEditarView />} />
                {/* *************Rotas  de Assinatura de Documento */}
                <Route path={configUrls.DOCUMENTO_ASSINAR_LIST_RT} element={<DocumentoAssinarListForm />} />
                <Route path={configUrls.DOCUMENTO_ASSINAR_RT} element={<DocumentoAssinarView />} />
                {/* *************Rotas  do Site */}
                {/* prettier-ignore */}
                <Route path={configUrls.SITE_HOME} element={<SiteHome />} />
                {/* *************Rotas  do MENU PRINCIPAL */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_PAI_LIST} element={<MenuPaiListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_PAI_CREATE} element={<MenuPaiCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_PAI_EDIT} element={<MenuPaiCreate />} />
                {/* *************Rotas  do SUBMENU 02 */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_FILHO_EDIT} element={<MenuFilhoCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_FILHO_LIST} element={<MenuFilhoListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_FILHO_CREATE} element={<MenuFilhoCreate />} />
                {/* *************Rotas  do SUBMENU 03 */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_NETO_LIST} element={<MenuNetoListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_NETO_CREATE} element={<MenuNetoCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_MENU_NETO_EDIT} element={<MenuNetoCreate />} />
                {/* *************Rotas  de Notícias do Site */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_NOTICIA_CREATE} element={<NoticiaCreateForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_NOTICIA_LIST} element={<NoticiaListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_NOTICIA_EDIT} element={<NoticiaCreateForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_NOTICIA_PUBLIC_LIST} element={<NoticiaPublicList />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_NOTICIA_PUBLIC_VIEW} element={<NoticiaView />} />
                {/*************  Rotas do MENU Publicação Oficial */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_PUBLICACAO_OFICIAL_LIST} element={<PublicacaoOficialListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_PUBLICACAO_OFICIAL_CREATE} element={<PublicacaoOficialCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_PUBLICACAO_OFICIAL_EDIT} element={<PublicacaoOficialCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_PUBLICACAO_OFICIAL_PUBLIC_LIST} element={<PublicacaoOficialPublicList />} />
                <Route path={configSiteUrls.SITE_PUBLICACAO_OFICIAL_PUBLIC_LIST_PAR} element={<PublicacaoOficialPublicList />} />

                {/*************  Rotas do MENU Licitação */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_LICITACAO_LIST} element={<LicitacaoListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_LICITACAO_CREATE} element={<LicitacaoCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_LICITACAO_EDIT} element={<LicitacaoCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_LICITACAO_PUBLIC_LIST} element={<LicitacaoPublicList />} />

                {/* *************Rotas  do Tipo de Publicação Oficial  */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_TIPO_PUBLICACAO_OFICIAL_LIST} element={<TipoPublicacaoOficialListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_TIPO_PUBLICACAO_OFICIAL_CREATE} element={<TipoPublicacaoOficialCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_TIPO_PUBLICACAO_OFICIAL_EDIT} element={<TipoPublicacaoOficialCreate />} />

                {/* *************Rotas  do Cadastro de Vereadores  */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_VEREADOR_LIST} element={<VereadorListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_VEREADOR_CREATE} element={<VereadorCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_VEREADOR_EDIT} element={<VereadorCreate />} />

                {/* *************Rotas  do OUVIDORIA  */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_OUVIDORIA_PUBLIC_MENU} element={<OuvidoriaMenu />} />
                <Route path={configSiteUrls.SITE_OUVIDORIA_PUBLIC_CREATE} element={<OuvidoriaCreate />} />
                <Route path={configSiteUrls.SITE_OUVIDORIA_PUBLIC_CONSULT} element={<OuvidoriaConsultaView />} />
                <Route path={configSiteUrls.SITE_OUVIDORIA_LIST} element={<OuvidoriaListForm />} />
                <Route path={configSiteUrls.SITE_OUVIDORIA_EDIT} element={<OuvidoriaEdit />} />

                <Route path={configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_MENU} element={<AcessoInformacaoMenu />} />
                <Route path={configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_CREATE} element={<AcessoInformacaoCreate />} />
                <Route path={configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_CONSULT} element={<AcessoInformacaoConsultaView />} />
                <Route path={configSiteUrls.SITE_ACESSO_INFORMACAO_LIST} element={<AcessoInformacaoListForm />} />
                <Route path={configSiteUrls.SITE_ACESSO_INFORMACAO_EDIT} element={<AcessoInformacaoEdit />} />

                <Route path={configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_MENU} element={<CentroApoioMenu />} />
                <Route path={configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_CREATE} element={<CentroApoioCreate />} />
                <Route path={configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_CONSULT} element={<CentroApoioConsultaView />} />
                <Route path={configSiteUrls.SITE_CENTRO_APOIO_LIST} element={<CentroApoioListForm />} />
                <Route path={configSiteUrls.SITE_CENTRO_APOIO_EDIT} element={<CentroApoioEdit />} />

                {/* *************Rotas  do Cadastro de Usuários  */}
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_USUARIO_LIST} element={<UsuarioListForm />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_USUARIO_CREATE} element={<UsuarioCreate />} />
                {/* prettier-ignore */}
                <Route path={configSiteUrls.SITE_USUARIO_EDIT} element={<UsuarioCreate />} />

                {/* *************Rotas  alternativas do Site Home */}
                {/* prettier-ignore */}
              
                {/* prettier-ignore */}
                <Route path={configUrls.SITE_HOME} element={<SiteHome />}/>

                {/* *************Rotas  alternativas do Site Home */}
                {/* prettier-ignore */}
                <Route path="/escola-legislativo" element={<EscolaLegislativoHome />} />

                {/* prettier-ignore */}
                <Route path={configUrls.ESCOLA_LEGISLATIVO_HOME} element={<EscolaLegislativoHome />}/>

                {/* *************Rotas  de Autenticação */}
                <Route path={configUrls.SABER_HOME} element={<HomePage />} />
                <Route path={configUrls.SABER_LOGIN} element={<Login />} />
                <Route path={configUrls.SITE_LOGIN} element={<Login />} />

                {/* *************Rotas  de Erro */}
                <Route path="*" element={<NotFoundPage />} />
                <Route path={configUrls.NOT_FOUND} element={<NotFoundPage />} />
                <Route path={configUrls.FORBIDDEN} element={<ForbiddenPage />} />

                <Route path="/" element={<Navigate to={configUrls.SITE_HOME} replace />} />
              </Routes>
            </Layout>
          </div>
        </SnackbarProvider>
      </ThemeProvider>
    </PrimeReactProvider>
  );
}

export default App;
